import z from 'zod';
import {epochTimestamp} from '../_other';
import {tradeDirectionSchema} from './TradeDirection';
import {tradeStatusSchema} from './TradeStatus';
import {tradeMessageWriteSchema} from './tradeMessageWriteSchema';

export const tradeWriteSchema = z.object({
  /** datetime string of first trade in replay, manual in manual journaling */
  sessionId: z.string().trim().min(1).max(100),
  /** like order id in broker, and 1, 2, 3 etc in replay */
  tradeId: z.string().trim().min(1).max(100),

  // trade details
  symbol: z.string().trim().min(1).max(100),
  positionSize: z.number().positive(),
  direction: tradeDirectionSchema,

  // entry
  entryPrice: z.number().positive(),
  openedAt: epochTimestamp,

  /**
   * Exit price; **`0` means not set** (position still open). A closed position uses a positive exit price.
   */
  exitPrice: z.number().min(0).default(0),
  /**
   * Close time (epoch ms, UTC); **`0` means not closed** on the chart / not recorded yet.
   */
  closedAt: epochTimestamp.default(0),

  /**
   * Absolute profit/loss in account currency when known (e.g. from TradingView).
   * **`0` means not set** (treat like omitted: derive from prices when the position is closed).
   */
  profitLoss: z.number().default(0),

  // internal stuff
  status: tradeStatusSchema,

  // other stuff
  /** Note for the trade, shown in the trade detail page. intend to be used for analysing the trade afterwards */
  note: z.string().default(''),
  tags: z.array(z.string()).default([]),
  messages: tradeMessageWriteSchema.array().default([]),
});

export interface TradeWrite extends z.infer<typeof tradeWriteSchema> {}
